/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Perks_Carry_AboveInputs */



/**
* | output |
* | --- |
* | "Move Colossus's role above @{role} in Server Settings → Roles." |
*
* @param {Perks_Carry_AboveInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_carry_above = /** @type {((inputs: Perks_Carry_AboveInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Carry_AboveInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Поднимите роль Colossus выше @${i?.role} в разделе «Настройки сервера» → «Роли».`)
	return /** @type {LocalizedString} */ (`Move Colossus's role above @${i?.role} in Server Settings → Roles.`)
});